module.exports = __webpack_public_path__ + "img/img11.34b30723.png";